module.exports = __webpack_public_path__ + "static/media/warn_icon.52dd6a0d.svg";